

import { render } from "@testing-library/react";
import { Button, Card, Col, Dropdown, Input, message, Modal, notification, Row, Spin, Table, Tag, Tooltip } from "antd";
import network from "network/network";
import React, { useEffect, useReducer, useRef, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectCustomerList as fetchCustomerList } from "utils/redux/actions/customerActions"; // Renamed
import { CheckCircleOutlined, CloseCircleOutlined, DashboardOutlined, DeleteOutlined, EditOutlined, EllipsisOutlined, ExportOutlined, EyeOutlined, FileExcelOutlined, LoadingOutlined, PlusCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import tools from 'tools';
import * as XLSX from 'xlsx';
import AvatarStatus from "components/shared-components/AvatarStatus";
import { t } from "i18next";
import ReusableButton from "components/Elements/ReusableButton";
import helperFunc from "helpers/helperFunc";
import { useTranslation } from "react-i18next";
import globalConstant from "constants/globalConstant";
import campaignDetail from "../campaign-detail";

const CustomerDashboard = (props) => {

	const [customerData, setCustomerData] = useState([]);
	// const [filteredData, setFilteredData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [searchValue, setSearchValue] = useState("");
	const [searchDetail,setSearchDetail]=useState();
	const [isModal, setIsmodal] = useState(false);
	const [clientCampaignDetails, setClientCampaignDetails] = useState();
	const [customerId, setCustomerId] = useState(0);
	const [campaignModal, setCampaignModal] = useState(false);
	const navigate = useNavigate();
	const { t, } = useTranslation();


	useEffect(() => {
		if (!isModal) {
			selectCustomerList();
		}

	}, [isModal]);

	const selectCustomerList = async () => {
		var params = {};

		var result = await network.get("/admin/Client/GetCustomersWithDetail", params, false);


		if (result.isSuccess && result.data.isSuccess) {
			const uniqueData = result.data.data.filter((value, index, self) =>
				index === self.findIndex((t) => t.customerid === value.customerid)
			);

			setCustomerData(uniqueData);
			// setFilteredData(uniqueData);

		}
		setLoading(false);

	}
	const changeCustomerStatusPrev = (row) => {
		const newStatus = row.customerstatus == globalConstant.customerStatus.passive ? globalConstant.customerStatus.active : globalConstant.customerStatus.passive

		const message = newStatus == globalConstant.customerStatus.passive ? t("makePassiveConfirmMessage") : t("makeActiveConfirmMessage")

		helperFunc.showConfirm({
			content: message,
			title: t("warning"), onConfirm: () => changeCustomerStatusConfirm(row, newStatus)
		});
	}
	const changeCustomerStatusConfirm = async (row, newStatus) => {

		setLoading(true);

		var params = {
			customerId: row.customerid,
			status: newStatus
		}

		var result = await network.get("/admin/client/updateClientStatus", params, false);

		setLoading(false);
		if (result.isSuccess) {


			message.success(t("clientStatusUpdateSuccess"))


			var customerIndex = customerData.findIndex(w => w.customerid == row.customerid);
			var data = JSON.parse(JSON.stringify(customerData));
			if (customerIndex != -1) {

				data[customerIndex].customerstatus = newStatus;
			}
			console.log(customerIndex);
			setCustomerData(data);

		} else {
			message.error(t("clientStatusUpdateError"))
		}

	}

	const handleClientCampaignOpen = async (record) => {

		var result = await network.get("/admin/Campaign/GetAllClientCampaignList", { clientId: record.customerid }, false);

		if (result.isSuccess) {
			setCampaignModal(true);
			setClientCampaignDetails(result.data.data.filter(item => item.campaignId !== null).reverse());

			
		}
	}

	const onSearch = (e) => {
		const value = e.currentTarget.value;
		setSearchValue(value);

		// if (value.length > 0) {
		// 	const filtered = customerData.filter((item) => {
		// 		return (
		// 			item.customername.toUpperCase().includes(value.toUpperCase()) ||
		// 			item.customernumber.toUpperCase().includes(value.toUpperCase()) ||
		// 			item.email?.toUpperCase().includes(value.toUpperCase())
		// 		);
		// 	});
		// 	setFilteredData(filtered); // Update filtered data
		// } else {
		// 	setFilteredData(customerData); // Reset to original data
		// }
	}

	const importExcelClick = () => {

		navigate(`/campaign-customer-excel`)

	}

	const getItems2 = (record) => [
		{
			key: 'detail',
			label: (
				<div onClick={() => navigate(`/customer-edit/${record.customerid}`)}>
					<EditOutlined />
					<span className="ml-2">{t('edit')}</span>
				</div>
			)
		},
		{
			key: 'delete',
			label: (
				<div onClick={() => changeCustomerStatusPrev(record)}>
					<DeleteOutlined />
					<span className="ml-2">{record.customerstatus !== globalConstant.customerStatus.passive ? t('makePassive') : t('makeActive')}</span>
				</div>
			)
		},
		{
			key: 'show',
			label: (
				<div onClick={() => handleClientCampaignOpen(record)}>
					<EyeOutlined />
					<span className="ml-2">{t("campaignHistory")}</span>
				</div>
			)
		}
	];

	const filteredClientData = (clientCampaignDetails || []).filter(item => {
        if (searchDetail) {

            const normalizeText = (text) =>
                text.toLocaleLowerCase('tr').normalize('NFKC');

            const isSearch = searchDetail
                ? Object.values(item).some(value =>
                    normalizeText(String(value)).includes(normalizeText(searchDetail))
                )
                : true;

            return isSearch;
        }
        return true; // Eğer filtreleme şartı yoksa tüm veriyi döndür
    });
	
	const campaignColumn = [
		{
			title: t("campaignName"),
			dataIndex: "campaignName",
			sorter: (a, b) => tools.antdTableSorter(a, b, 'campaignName'),
			render: (_, record) => (
				<div className="d-flex align-items-center">
					{record.campaignName}
				</div>
			),

		},
		{
			title: t("createdDate"),
			dataIndex: "messageDate",
			sorter: (a, b) => tools.antdTableSorter(a, b, 'messageDate'),
			render: (_, record) => (
				<div className="d-flex align-items-center">
					{new Date(record.messageDate).toLocaleDateString("tr-TR")}
				</div>
			),

		},
		{
			title: t("replybuttondesc"),
			dataIndex: "replyMessage",
			sorter: (a, b) => {
				if (!a.replyMessage && !b.replyMessage) return 0;
				if (!a.replyMessage) return 1;
				if (!b.replyMessage) return -1;
				return a.replyMessage.localeCompare(b.replyMessage);
			},
			render: (_, record) => (
				<div className="d-flex align-items-center">
					{record.replyMessage}
				</div>
			),

		},
		{
			title: t("status"),
			dataIndex: "status",
			sorter: (a, b) => tools.antdTableSorter(a, b, 'status'),
			render: (_, record) => (
				<div className="d-flex align-items-center">
					<div className='my-1 '>
						{record.status == "read" ? (
							<><Tag color={"orange"}>{t('read')}</Tag></>
						) : record.status == "sent" ? (
							<><Tag color={"green"}>{t('sent')}</Tag></>
						) : record.status == "delivered" ? (
							<><Tag color={"yellow"}>{t('delivered')}</Tag> </>
						) : record.status == "failed" ? (
							<Tag color={"red"}>{t('failed')}</Tag>
						) : (
							<><Tag color={"red"}>{t('notDelivered')}</Tag> </>
						)}
					</div>
				</div>
			),

		},
		{
			title: t("activityStatus"),
			dataIndex: "activityDesc",
			sorter: (a, b) => {
				if (!a.activityDesc && !b.activityDesc) return 0;
				if (!a.activityDesc) return 1;
				if (!b.activityDesc) return -1;
				return a.activityDesc.localeCompare(b.activityDesc);
			},
			render: (_, record) => (
				<div className="d-flex align-items-center">
					{record.activityDesc}
				</div>
			),

		},

	]
	const tableColumns = [
		{
			title: t('customerName'),
			dataIndex: "customername",
			sorter: (a, b) => tools.antdTableSorter(a, b, 'customername'),
			render: (_, record) => (
				<div className="d-flex align-items-center">
					<AvatarStatus src={"/img/avatars/user-blank-image.jpg"}></AvatarStatus>
					<h5>{record.customername}</h5>
				</div>
			),
			shouldCellUpdate: (record, prevRecord) => record.customername !== prevRecord.customername,
		},
		{
			title: t('customerNumber'),
			dataIndex: "customernumber",
			sorter: (a, b) => tools.antdTableSorter(a, b, 'customernumber'),
			render: (_, record) => (
				<div>
					+{record.customernumber}
				</div>
			),
			shouldCellUpdate: (record, prevRecord) => record.customernumber !== prevRecord.customernumber,

		},
			{
			title: t('customerTitle'),
			dataIndex: "customertitle",
			sorter: (a, b) => tools.antdTableSorter(a, b, 'customertitle'),
			render: (_, record) => (
				<div>
					{record.customertitle != null ? record.customertitle : '-'}
				</div>
			),
			shouldCellUpdate: (record, prevRecord) => record.customertitle !== prevRecord.customertitle,

		},
		{
			title: t('regDate'),
			dataIndex: "insertdate",
			sorter: (a, b) => tools.antdTableSorter(a, b, 'insertdate'),
			render: (_, record) => (
				<div className="font-weight-normal">
					{new Date(record.insertdate).toLocaleString('tr-TR').replace(/:\d{2}$/, '')}
				</div>
			),
			shouldCellUpdate: (record, prevRecord) => record.insertdate !== prevRecord.insertdate,
		},
		{
			title: "E-Mail",
			dataIndex: "email",
			sorter: (a, b) => tools.antdTableSorter(a, b, 'email'),
			render: (_, record) => (
				<div>
					{record.email != null ? record.email : '-'}
				</div>
			),
			shouldCellUpdate: (record, prevRecord) => record.email !== prevRecord.email,
		},
		{
			title: t("status"),
			dataIndex: "customerstatus",
			sorter: (a, b) => tools.antdTableSorter(a, b, 'customerstatus'),
			render: (_, record) => (
				record.customerstatus !== globalConstant.customerStatus.passive ? (

					<div className='my-4 '>
						<><Tag color={"green"}>{t('active')}</Tag></>
					</div>


				) : (

					<div className='my-4 '>
						<><Tag color={"red"}>{t('inactive')}</Tag></>
					</div>

				)
			),
			shouldCellUpdate: (record, prevRecord) => record.email !== prevRecord.email,
		},
		{
			title: t("cancelStatus"),
			dataIndex: "isapproved",
			sorter: (a, b) => tools.antdTableSorter(a, b, 'isapproved'),
			render: (_, record) => (
				record.isapproved ? (

					<div className='my-4 ml-3' style={{ width: "fit-content", display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
						<Tooltip title={t("exist")}>
							<CheckCircleOutlined style={{ fontSize: 23, color: '#52c41a' }} className='mr-2 ' />
						</Tooltip>
					</div>


				) : (

					<div className='my-4 ml-3' style={{ width: "fit-content", display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
						<Tooltip title={t("cancelled")}>
							<CloseCircleOutlined style={{ fontSize: 23, color: '#b82a23' }} className='mr-2 ' />
						</Tooltip>
					</div>

				)
			),

		},
		{
			title: t('customerDetail'),
			dataIndex: "",
			render: (_, record) => (
				<Dropdown menu={{ items: getItems2(record) }} trigger={['click']}>
					<div className="ellipsis-dropdown" style={{ cursor: 'pointer' }}>
						<EllipsisOutlined />
					</div>
				</Dropdown>
			)
		}
	]

	const getStatusText = (record) => {

		return record.customerstatus !== globalConstant.customerStatus.passive ? t('active') : t('inactive');
	}

	const handleExcelExport = () => {
		const excelData = filteredData.map((record) => ({
			
			[t('customerName')]: record.customername,
			[t('customerNumber')]: record.customernumber,
			[t('customerTitle')]: record.customertitle != null ? record.customertitle : "",
			[t('regDate')]: new Date(record.insertdate).toLocaleDateString(),
			[t('Email')]: record.email,
			[t('status')]: getStatusText(record),
			[t("cancelStatus")]: record.isapproved == true ? t("exist") : t("cancelled"),
		}));

		// Create a new worksheet and add the data
		const worksheet = XLSX.utils.json_to_sheet(excelData);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "Customers");

		// Export to Excel
		XLSX.writeFile(workbook, "CustomerData.xlsx");
	}

	const getFilteredData = () => {

		if (searchValue.length > 0) {
			const filtered = customerData.filter((item) => {
				return (
					item.customername.toUpperCase().includes(searchValue.toUpperCase()) ||
					item.customernumber.toUpperCase().includes(searchValue.toUpperCase()) ||
					item.email?.toUpperCase().includes(searchValue.toUpperCase())
				);
			});
			return filtered;
		} else {
			return customerData
		}
	}
	const filteredData = getFilteredData();

	const addCustomer = () => {

		navigate(`/customer-edit/0`)
	}
	return (
		<Spin size="large" spinning={loading}>
			<div>
				<Row className="mb-3" justify={"space-between"}>

					<Col span={4}>
						<Input
							placeholder={t('searchInCustomers')}
							prefix={<SearchOutlined />}
							onChange={onSearch}
						/>
					</Col>
					<div className="row-justify-between ">
						<ReusableButton
							variant="campaign"
							text={t('Export')}
							onClick={handleExcelExport}
							icon={<ExportOutlined />}
							className={"mr-2"}

						/>
						<ReusableButton
							variant="campaign"
							text={t('importExcel')}
							onClick={importExcelClick}
							icon={<FileExcelOutlined />}
							className={"mr-2"}
						/>
						<ReusableButton
							variant="campaign"
							text={t('addCustomer')}
							onClick={addCustomer}
							icon={<PlusCircleOutlined />}
						/>
					</div>

				</Row>

				<Card>
					<div className="table-responsive">
						<Table
							columns={tableColumns}
							dataSource={filteredData}
							size="middle"
							rowKey={"customerid"}
							key={JSON.stringify(customerData)}
							pagination={{
								total: filteredData.length,
								showTotal: (total) => `${t("total")}: ${total}`
							}}
						/>
					</div>
				</Card>

				<Modal title={t("campaignHistory")} width={"800px"} closable={true} footer={null} open={campaignModal} onCancel={() => setCampaignModal(false)}>
					<div className="mb-3" style={{ width: "200px" }}>
						<Input onChange={(event)=>setSearchDetail(event.target.value)} placeholder={t("search")}></Input>
					</div>
					<Table
						columns={campaignColumn}
						dataSource={filteredClientData}
						size="small"
						//rowKey={"customerid"}
						scroll={{ y: 350 }}

					/>
				</Modal>
			</div>
		</Spin>




	);
}

function mapStateToProps(state) {
	return {
	}
}

function mapDispatchToProps(dispatch) {
	return {
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerDashboard);
